import { FC } from 'react';
import Box from '@mui/material/Box/Box';

import { HeroSection } from 'components/HeroSection';
import { Button } from 'components/Buttons';

import {
  BigImageWrapper,
  BlueButtonWrapper,
  ButtonWrapper,
  Container,
  HeroSubTitleLink,
  DescriptionContainer,
  FirstSectionWrapper,
  HeroDescription,
  HeroSubTitle,
  HeroTitle,
  Item,
  ItemsWrapper,
  ItemText,
  ItemTitle,
  SmallImageWrapper,
  WebImageWrapper,
} from './Hero.styles';

import WebImage from 'assets/top-web.webp';
import { IHeroData } from 'types/customer-case';
import { Link } from 'react-router-dom';
import { BOOK_A_DEMO_LINK } from 'constants/common';
import useMediaQuery from '@mui/material/useMediaQuery/useMediaQuery';
import { theme } from 'styles/theme';
import { customerCaseMeta } from 'constants/pages';

export const Hero: FC<IHeroData> = ({
  heroDescription,
  heroListItems,
  heroListTitle,
  heroTitle,
  buttonLabel,
  buttonLink,
  heroImages,
}) => {
  const isTablet = useMediaQuery(theme.breakpoints.down(1024));

  return (
    <HeroSection>
      <Box width="100%">
        <Container>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            paddingBottom="80px"
            gap="80px"
          >
            <FirstSectionWrapper>
              <HeroTitle>{heroTitle}</HeroTitle>

              <DescriptionContainer>
<HeroDescription 
    as="p" 
    dangerouslySetInnerHTML={{ 
      __html: heroDescription
        .replace(/\n/g, '<br />')
        .replace(/\*\*(.*?)\*\*/g, '<b>$1</b>')
    }} 
  />

                <ButtonWrapper>
                  <BlueButtonWrapper>
                    <a href={BOOK_A_DEMO_LINK} target="_blank" rel="noreferrer">
                      <Button width={isTablet ? 'full' : 176}>Book a Demo</Button>
                    </a>
                  </BlueButtonWrapper>

                  <Link to={customerCaseMeta.url}>
                    <Button btnType="secondary">
                      Explore more Customer cases
                    </Button>
                  </Link>
                </ButtonWrapper>
              </DescriptionContainer>
            </FirstSectionWrapper>

            <Box
              display={{
                md: 'flex',
                xxs: 'none',
              }}
              justifyContent="space-between"
            >
              <Box marginRight="16px">
                <Box marginBottom="16px">
                  <SmallImageWrapper>
                    <img src={heroImages.firstImage.imageSrc} alt={heroImages.firstImage.altText} />
                  </SmallImageWrapper>
                </Box>

                <BigImageWrapper>
                  <img src={heroImages.secondImage.imageSrc} alt={heroImages.secondImage.altText} />
                </BigImageWrapper>
              </Box>

              <Box>
                <Box marginBottom="16px">
                  <BigImageWrapper>
                    <img src={heroImages.thirdImage.imageSrc} alt={heroImages.thirdImage.altText} />
                  </BigImageWrapper>
                </Box>

                <SmallImageWrapper>
                  <img src={heroImages.fourthImage.imageSrc} alt={heroImages.fourthImage.altText} />
                </SmallImageWrapper>
              </Box>
            </Box>
          </Box>

          <Box
            position="relative"
            display="flex"
            flexDirection="column"
            alignItems="center"
            paddingTop={{
              md: '160px',
              xxs: '40px',
            }}
          >
            <HeroSubTitle>{heroListTitle}</HeroSubTitle>

            <Box margin="48px 0 80px" width="100%" display="flex" justifyContent="center">
              <Link to={buttonLink} style={{ textDecoration: 'none' }}>
                <HeroSubTitleLink>{buttonLabel}</HeroSubTitleLink>
              </Link>
            </Box>

            <ItemsWrapper>
              {heroListItems.map((item) => (
                <Item key={item.title}>
                  <Box>
                    <img src={item.Icon} />
                  </Box>

                  <ItemTitle>{item.title}</ItemTitle>

                  <ItemText>{item.description}</ItemText>
                </Item>
              ))}
            </ItemsWrapper>
          </Box>
        </Container>

        <WebImageWrapper>
          <img src={WebImage} alt="web" />
        </WebImageWrapper>
      </Box>
    </HeroSection>
  );
};
